export interface AppConfig {
  supabaseUrl: string;
  supabaseAnonKey: string;
  assistantsBackendUrl: string;
  agentsBackendUrl: string;
  mcpBackendUrl: string;
  azureClientId: string;
  azureTenantId: string;
}

export function getAppConfig(): AppConfig {
  const origin = typeof window !== 'undefined' ? window.location.origin : '';

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || `${origin}/supabase`;
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';
  // When VITE_ASSISTANTS_BACKEND_URL is set, use it directly.
  // When empty/unset, use '' so requests go to the current origin,
  // which Vite's dev proxy forwards to the backend.
  const assistantsBackendUrl = import.meta.env.VITE_ASSISTANTS_BACKEND_URL ?? '';
  const agentsBackendUrl = import.meta.env.VITE_AGENTS_BACKEND_URL ?? '';
  const rawMcpBackendUrl = import.meta.env.VITE_MCP_BACKEND_URL;
  const mcpBackendUrl =
    rawMcpBackendUrl && rawMcpBackendUrl !== 'undefined' && rawMcpBackendUrl !== 'null'
      ? rawMcpBackendUrl
      : `${origin}/mcp`;

  // Azure app registration for NAA (Nested App Authentication)
  const azureClientId = import.meta.env.VITE_AZURE_CLIENT_ID || '';
  const azureTenantId = import.meta.env.VITE_AZURE_TENANT_ID || 'common';

  return {
    supabaseUrl,
    supabaseAnonKey,
    assistantsBackendUrl,
    agentsBackendUrl,
    mcpBackendUrl,
    azureClientId,
    azureTenantId,
  };
}
